import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class ManagerExecutionService {
  managerData: any;
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  fileteredData: any = [];
  UserData: any;
  From: any;
  To: any;
  ManagerHeaderData: any = { Group: '', Plant: '', FromDate: '', ToDate: '' }
  TechData: any;

  constructor(private http: HttpClient) { }

  setManagerHeaderData(data: any) {
    this.ManagerHeaderData.Group = data.Group
    this.ManagerHeaderData.Plant = data.Plant
    this.ManagerHeaderData.FromDate = data.FromDate
    this.ManagerHeaderData.ToDate = data.ToDate
  }
  getManagerHeaderData() {
    return this.ManagerHeaderData;
  }

  setFromDate(date: any) {
    this.From = date;
  }

  getFromDate() {
    return this.From;
  }

  setToDate(date: any) {
    this.To = date;
  }

  getToDate() {
    return this.To;
  }

  setManagerData(data: any) {
    this.managerData = data;
  }

  getManagerData() {
    return this.managerData;
  }

  setUserData(data: any) {
    this.UserData = data;
  }

  getUserData() {
    return this.UserData;
  }

  setTechData(data: any) {
    this.TechData = data;
  }

  getTechData() {
    return this.TechData;
  }

  getOperatorData(data: any): any {
    // return this.http.get<any>(this.baseUrl + 'find-manager-execution', { params: data });
    return this.http.get<any>(this.O3CoreApiUrl + 'PMManagerExecution/showManagerExecutionWO', { params: data });
  }

  getUserList(): any {
    return this.http.post<any>(this.O3CoreApiUrl + 'Account/GetUserList', []);
  }

  //NOT IN USE
  // getTechnicianBySkill(data: any) {
  //   return this.http.get<any>(this.baseUrl + 'getTechnicianBySkill', { params: data });
  // }

  addManagerData(data: any): Observable<any[]> {
    //return this.http.post<any[]>(this.baseUrl + 'add-manager-execution', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'PMManagerExecution/AddManagerExecutionWO', data);
  }

  updateManagerData(data: any): Observable<any[]> {
    // return this.http.put<any[]>(this.baseUrl + 'update-manager-execution', data);
    return this.http.put<any[]>(this.O3CoreApiUrl + 'PMManagerExecution/updateManagerExecutionWO', data);
  }


}
